import { LayaGL } from "../../layagl/LayaGL";
import { BlendModeHandler } from "../canvas/BlendMode";
import { GraphicsShaderInfo } from "../shader/d2/value/GraphicsShaderInfo";
import { SubmitKey } from "./SubmitKey";
export class SubmitBase {
    constructor() {
        this.clipInfoID = -1;
        this._id = 0;
        this._renderType = 0;
        this._key = new SubmitKey();
        this.vertexs = [];
        this.blockIndexs = [];
        this.indexCount = 0;
        this.indices = [];
        this._internalInfo = null;
        this.renderStateIsBySprite = true;
        this._id = ++SubmitBase.ID;
    }
    clear() {
        this._key.clear();
        this._internalInfo.clear();
        this.material = null;
        if (this.mesh) {
            this.mesh.clearBlocks(this.blockIndexs);
            this.mesh.clearIndexView(this.indexView);
            this.vertexs.length = 0;
            this.blockIndexs.length = 0;
            this.mesh = null;
        }
    }
    destroy() {
        this.clear();
        if (this.indexView) {
            this.indexView.destroy();
            this.indexView = null;
        }
        this._internalInfo.destroy();
        this._internalInfo = null;
    }
    appendData(info) {
        this.blockIndexs.push(...info.vertexBlocks);
        let vertexBlock = LayaGL.render2DRenderPassFactory.createGraphic2DVertexBlock();
        vertexBlock.positions = info.positions;
        vertexBlock.vertexViews = info.vertexViews;
        this.vertexs.push(vertexBlock);
    }
    update(runner, mesh, material) {
        var blendType = runner._nBlendType;
        let struct = runner.sprite._struct;
        let sBlendMode = struct.blendMode;
        this._key.blendShader = blendType;
        if (runner.globalCompositeOperation != sBlendMode) {
            BlendModeHandler.setShaderData(blendType, this._internalInfo.shaderData);
            this.renderStateIsBySprite = false;
        }
        this.mesh = mesh;
        this.material = material;
    }
    static create(runner, mesh, material) {
        var o = new SubmitBase();
        o._internalInfo = new GraphicsShaderInfo();
        o.update(runner, mesh, material);
        return o;
    }
}
SubmitBase.ID = 1;
SubmitBase.RENDERBASE = new SubmitBase();
